import { render, staticRenderFns } from "./FormResetPasswordToken.vue?vue&type=template&id=5f781d7e&"
import script from "./FormResetPasswordToken.vue?vue&type=script&lang=js&"
export * from "./FormResetPasswordToken.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports